$(document).ready(function () {
    handleModal();
    linkSelect2Autosubmit();
});

function linkSelect2Autosubmit() {
    var select = $('.select2');
    if (select.data('init') == null) {
        select.data('init', 1);
        select.select2();
    }
}

function openModalNewClient(event) {

    let modal = event.data('modal-id');
    let id = event.data('params');
    let post = [];
    if (id) {
        post.push({
            name: 'idGroup',
            value: id
        });
    } else {
        let form = $(document).find('.test-group-form');
        let data = form.serializeArray();
        data.forEach(function (v) {
            if (v.name != '_do') {
                post.push(v);
            }
        });
    }

    let href = $(modal).data('open-handle');
    $.nette.ajax({
        url: href,
        data: post,
        type: 'POST',
        off: {
            snippets: true
        }
    }).done(function () {
        $(modal).modal('toggle');
        reinitTooltips();
        linkSelect2Autosubmit();
    });
}

function handleModal() {
    $(document).on("click", ".toggle-modal", function (e) {
        e.preventDefault();
        let modal = $(this).data('modal-id');
        let params = $(this).data('params');
        let href = $(modal).data('open-handle');
        $.nette.ajax({
            url: href,
            data: {data: params},
            type: 'GET',
            off: {
                snippets: true
            }
        }).done(function () {
            $(modal).modal('toggle');
            $(document).find(".float-button").show();
            linkSelect2Autosubmit();
        });
    });

    $(document).on("click", ".toggle-modal-new-client", function (e) {
        e.preventDefault();
        openModalNewClient($(this));
    });

    $(document).on("click", ".save-modal-form", function (e) {
        e.preventDefault();
        let save = $(this).data('save-handle');
        let form = $(this).closest("form");
        let modal = $(this).closest("div.modal");
        let data = form.serializeArray();
        let postData = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].name !== '_do') {
                postData.push(data[i]);
            }
        }

        $.nette.ajax({
            url: save,
            type: 'POST',
            off: {
                snippets: true
            },
            data: postData
        }).done(function (payload) {
            $(modal).modal('toggle');
            if (payload.successMessage) {
                toastr.success(payload.successMessage);
            }
            if (payload.errorMessage) {
                toastr.error(payload.errorMessage);
            }
        });
    });
}

function reinitTooltips() {
    $(".tooltip").remove();
    $('[data-toggle="tooltip"]').tooltip();
}
